import { render, staticRenderFns } from "./AppointmentsTab.vue?vue&type=template&id=69b16ac2&scoped=true"
import script from "./AppointmentsTab.vue?vue&type=script&lang=js"
export * from "./AppointmentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b16ac2",
  null
  
)

export default component.exports